import styled from 'styled-components';

export const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.greyColors['grey-20']};
  margin: 1.5rem 0;
  width: 100%;
`;
